import { Directive, ElementRef, EventEmitter, Output, Input, OnDestroy } from '@angular/core';

@Directive({
    selector: '[calLazyLoad]',
    standalone: true
})
export class LazyLoadDirective implements OnDestroy {
  @Output() lazyLoad = new EventEmitter<void>();
  @Input() disabled = false;

  private observer: IntersectionObserver;

  constructor(private el: ElementRef) {
      this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && !this.disabled) {
              this.lazyLoad.emit();  // Emit event when element is visible
              // this.observer.disconnect();
          }
      });

      this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
      this.observer.disconnect();
  }
}